import { RuleSet } from 'styled-components';
import React, { ReactNode } from 'react';
import { IconColor } from '../../Icon';
import { SVGComponent } from '../../Icon/types';

export enum ChipsTheme {
  Blue = 'blue',
  White = 'white',
  Dark = 'dark'
}

export interface ChipsProps {
  text: string | ReactNode;
  id?: string;
  icon?: SVGComponent | null;
  type?: 'single' | 'checkbox' | 'button';
  name?: string;
  value?: string | number | boolean;
  storedValue?: string | number | boolean | string[];
  style?: React.CSSProperties;
  styles?: RuleSet<object>;
  dirty?: boolean | string | number;
  onClick?: (e?: React.MouseEvent) => void;
  resetHandler?: (e?: React.MouseEvent) => void;
  cypress?: string;
  stat?: string;
  chipsTheme?: ChipsTheme;
  onReset?: () => void;
  iconSize?: number;
  isDark?: boolean;
  iconType?: 'angle' | 'close';
  useDirtyAsActive?: boolean;
  color?: IconColor;
  iconActiveColor?: IconColor;
  iconNeedColorChange?: boolean;
  activeIcon?: SVGComponent;
  hasCustomOnChange?: boolean;
  isTextPadding?: boolean;
  borderRadius?: string;
}
